// extracted by mini-css-extract-plugin
export var deleteModal = "_gv-0";